export default __webpack_public_path__ + "static/media/logo-light.2f42c4a5.svg";